export enum ReasonType {
	'like' = 'like',
	'dislike' = 'dislike'
}
